module.exports = __webpack_public_path__ + "img/placeholder.75d6a90b.png";